import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantService {

  constructor() { }
  public static ONHOLD = "ONHOLD";
  public static RETURNED_FROM_BENEFICIARY = "RETURNED_FROM_BENEFICIARY";
  public static IN_PROCESS = "IN_PROCESS";
  public static SENT_TO_BENEFICIARY = "SENT_TO_BENEFICIARY";
  public static encryptionSecret="YblSonSheNeebal";
  public static Secret16Byte="HiSoMuMaJaSaPaSa";
  public static encoded16ByteSecret="SGlTb011TWFKYVNhUGFTYQ==";
  public static OTP_VERIFIED_STATUS="OTP_VERIFIED";
  public static USER_CREATION="USER_CREATION";
  public static USER_UPDATION="USER_UPDATION";
  public static PROFILE_CREATION="PROFILE_CREATION";
  public static PROFILE_UPDATION="PROFILE_UPDATION";
  public static USER_RESET_PASSWORD="USER_RESET_PASSWORD";
  public static USER_UNLOCK_ACCOUNT="USER_UNLOCK_ACCOUNT";
  public static STAFF_CREATION="STAFF_CREATION";
  public static STAFF_UPDATION="STAFF_UPDATION";

  public static AWAITING_CREATION="Awaiting Creation";
  public static AWAITING_UPDATION="Awaiting Update";
  public static AWAITING_RESET_PASSWORD="Awaiting Reset Password";
  public static AWAITING_UNLOCK="Awaiting Unlock";

  public static ORG_CREATION="ORG_CREATION"
  public static ORG_ENABLED="ORG_ENABLED";
  public static ORG_DISABLED="ORG_DISABLED";
  public static ORG_UPDATION="ORG_UPDATION"
  
  public static AWAITING_ORG_CREATION="Awaiting Creation";
  public static AWAITING_ORG_ENABLED="Awaiting Enabled";
  public static AWAITING_ORG_DISBALED="Awaiting Disabled";
  public static AWAITING_ORG_UPDATION="Awaiting Updation";

  public static ACTIVE_BINARY="1";
  public static INACTIVE_BINARY="0";
  public static ACTIVE="Y";
  public static INACTIVE="N";
  public static APPROVED_FLAG="A";
  public static UNAPPROVED_FLAG="U";
  public static ENABLE="Enabled";
  public static DISABLED="Disabled";
  public static UNLOCK_ACCOUNT = 'N';
  public static LOCK_ACCOUNT = 'Y';
  public static LOCKED = 'Locked';
  public static UNLOCKED = 'Unlocked';
  public static SEED_PROFILE_NAME="Seed";
  public static FUND_REPORT_MODULE="FUND_REPORT";
  public static INW_REPORT_MODULE="INW_REPORT";
  public static BILLDESK_REPORT_MODULE="BILLDESK_REPORT";
  
  public static FUNDS_TRANSFER="FUNDS_TRANSFER";
  public static INWARD_REMITANCE="INWARD_REMITANCE";
  public static BILL_DESK="BILL_DESK";
  public static ECOLLECT="ECOLLECT";
  public static MICRO_SERVICE="MS";

  
  public static ECOL_TRANSACTION_ACTION_LIST_LIMIT=30;
  public static PAGE_CHANGE_DATA_LOSE_NOTE="In case, the user navigates to another page selected transactions will be deselected.";
  public static ALL="ALL";
  public static CANCELLED="Cancelled";
  public static ACTIVE_ALERT_STATUS="Active";
  public static ALERT_MODULE = "ALERT";

  public static COMPLETED_CODE ="C";
  public static COMPLETED_TEXT ="Completed";
  public static NOT_STARTED_CODE = "N";
  public static NOT_STARTED_TEXT = "Not Started"
  public static PENDING_APPROVAL_CODE = "I"
  public static PENDING_APPROVAL_TEXT = "Pending Approval"
  public static FAILED_CODE = "F";
  public static FAILED_TEXT = "Failed";
  public static ADMIN = "admin";
  public static USER = "user";
  public static STAFF = "staff";
  public static MAKER = "maker";
  public static CHECKER = "checker";
  public static VIEWER = "viewer";

  public static ECOL_REMITTER_FILE_UPLOAD = "ECOL_REMITTER_FILE_UPLOAD";
  public static CSV_SEPERATOR_PIPE = "|";
  public static E_STATEMENT = "E_STATEMENT";
  public static SERVICE_TYPE_PROFILE_LEVEL = "PROFILE_LEVEL";
  public static DATE_FORMAT_FOR_MOMENT =   "DD/MM/YYYY, hh:mm a";
  public static DATE_TYPE_FROM =   "FROM_DATE";
  public static DATE_TYPE_TO =   "TO_DATE";
  public static TRANSACTION_STATUS="TRANSACTION_STATUS";
  public static MODULE_SERVICE_REQUEST = "SERVICE_REQUEST";
  public static KEY_CATEGORY = "Category";
  public static KEY_ISSUE_TYPE_CODE="IssueTypeCode"
  public static SERVICE_REQUEST="SERVICE_REQUEST";
  public static SUBMITTED_AT="submittedAt";
  public static DESCENDING="desc";


  public static TRANSACTION_STATUS_COMPLETED ="COMPLETED";
  public static TRANSACTION_STATUS_FAILED = "FAILED";

  public static PIPE="|";

  public static ALPHA_NUMERIC_COMMA_DOT_SPACE_PATTERN='[a-zA-Z0-9., ]*';
  public static ALPHA_NUMERIC_COMMA_DOT_PATTERN='[a-zA-Z0-9., ]*';
  public static APLHA_NUMERIC_COMMA_PATTERN='[a-zA-Z0-9, ]*';
  public static APLHA_NUMERIC_UNDERSCORE_PATTERN='[a-zA-Z0-9_ ]*';
  public static AMOUNT_PATTERN='[0-9.]*';
  public static ALPHA_NUMERIC_PATTERN='[a-zA-Z0-9 ]*';
  public static ALPHA_NUMERIC_DOT_PATTERN='[a-zA-Z0-9. ]*';
  public static WHITE_SPACE=/^\S*$/;
  public static MOBILE_PATTERN='[0-9]*';
  public static ALPHA_PATTERN='[a-zA-z ]*'

  public static ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9 ]*$/;
  public static ALPHABETS_REGEX = /^[a-zA-Z_ ]*$/;

public static ROLE_ADMIN = "ADMIN";
  public static ROLE_STAFF_CHECKER = "STAFF_CHECKER";
  public static ROLE_STAFF_MAKER = "STAFF_MAKER";
  public static ROLE_STAFF_VIEWER =   "STAFF_VIEWER";
  public static ROLE_USER_MAKER = "USER_MAKER";

  public static INTERNAL_USER = "INTERNAL_USER";
  public static EXTERNAL_USER = "EXTERNAL_USER";

  public static ROLE_USER_CHECKER = "USER_CHECKER";
  public static ROLE_USER_VIEWER = "USER_VIEWER";

  public static USER_UNLOCK_MSG="Your Account is Locked. Please click on Unlock user button below to unlock your account";

  // Inw Remitance Constants
  public static MONEY_GRAM = "MONEYGRAMP";
  //public static MONEY_GRAM = "PARTNER16";

}
